/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie = function (b, j, m) {
    if (typeof j != "undefined") {
        m = m || {};
        if (j === null) {
            j = "";
            m.expires = -1
        }
        var e = "";
        if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) {
            var f;
            if (typeof m.expires == "number") {
                f = new Date();
                f.setTime(f.getTime() + (m.expires * 24 * 60 * 60 * 1000))
            } else { f = m.expires }
            e = "; expires=" + f.toUTCString()
        }
        var l = m.path ? "; path=" + (m.path) : "";
        var g = m.domain ? "; domain=" + (m.domain) : "";
        var a = m.secure ? "; secure" : "";
        document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("")
    } else { var d = null; if (document.cookie && document.cookie != "") { var k = document.cookie.split(";"); for (var h = 0; h < k.length; h++) { var c = jQuery.trim(k[h]); if (c.substring(0, b.length + 1) == (b + "=")) { d = decodeURIComponent(c.substring(b.length + 1)); break } } } return d }
};

/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

function alignHeight(selector) {

    jQuery(selector).css('height', '');
    var minHeight = 0;

    jQuery(selector).each(function () {
        if (minHeight < jQuery(this).outerHeight()) {
            minHeight = jQuery(this).outerHeight();
        }
    });

    if (minHeight > 0) {
        jQuery(selector).css('height', minHeight);
    }
};


Shopify.Products = (function () {

    var config = {
        howManyToShow: 3,
        howManyToStoreInMemory: 7,
        wrapperId: 'recently-viewed-products',
        templateId: 'recently-viewed-product-template',
        onComplete: null
    };

    var productHandleQueue = [];
    var wrapper = null;
    var template = null;
    var shown = 0;

    var cookie = {
        configuration: {
            expires: 90,
            path: '/',
            domain: window.location.hostname
        },
        name: 'shopify_recently_viewed',
        write: function (recentlyViewed) {
            jQuery.cookie(this.name, recentlyViewed.join(' '), this.configuration);
        },
        read: function () {
            var recentlyViewed = [];
            var cookieValue = jQuery.cookie(this.name);
            if (cookieValue !== null) {
                recentlyViewed = cookieValue.split(' ');
            }
            return recentlyViewed;
        },
        destroy: function () {
            jQuery.cookie(this.name, null, this.configuration);
        },
        remove: function (productHandle) {
            var recentlyViewed = this.read();
            var position = jQuery.inArray(productHandle, recentlyViewed);
            if (position !== -1) {
                recentlyViewed.splice(position, 1);
                this.write(recentlyViewed);
            }
        }
    };

    var finalize = function () {
        wrapper.show();
        var numberProductRecently = $('#recently-viewed-products .grid__item ').length;
        console.log(numberProductRecently);
        if ($(window).width() < 992 && $(window).width() > 767) {
            if (numberProductRecently > 3) {
                jQuery('#recently-viewed-products').not('.slick-initialized').slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: false,
                    arrows: true,
                    dots: false,
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                infinite: false,
                            }
                        }
                    ]
                });
            }
        }
        if ($(window).width() < 768) {
            if (numberProductRecently > 2) {
                jQuery('#recently-viewed-products').not('.slick-initialized').slick({
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: false,
                    arrows: true,
                    dots: false
                });
            }
        }
        if (numberProductRecently > 4) {
            jQuery('#recently-viewed-products').not('.slick-initialized').slick({
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            infinite: false,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: false,
                        }
                    }
                ]
            });
        }

        setTimeout(function () {
            alignHeight('.sub-collections a p');
            if (!$('body').hasClass('template-index') && !$('body').hasClass('template-cart')) {
                alignHeight('.product-recently-viewed .card-wrapper .card__heading');
            }
            alignHeight('.product-recently-viewed .card__inner');
            alignHeight('.product-recently-viewed .card-wrapper .price__container');
            alignHeight('.product-recently-viewed .card-wrapper .shipping-time-and-cart');
            alignHeight('.product-recently-viewed .footer-block__heading');
        }, 500);

        function swymCallbackFn(swat){
            swat.initializeActionButtons("#recently-viewed-products");
        }
        if(!window.SwymCallbacks){
            window.SwymCallbacks = [];
        }
        window.SwymCallbacks.push(swymCallbackFn);



        // If we have a callback.
        if (config.onComplete) {
            try { config.onComplete() } catch (error) { }
        }
    };

    var moveAlong = function () {
        if (productHandleQueue.length && shown < config.howManyToShow) {
            jQuery.ajax({
                dataType: 'json',
                url: '/products/' + productHandleQueue[1] + '.js',
                cache: false,
                success: function (product) {
                    template.tmpl(product).appendTo(wrapper);
                    productHandleQueue.shift();
                    shown++;
                    moveAlong();
                },
                error: function () {
                    cookie.remove(productHandleQueue[1]);
                    productHandleQueue.shift();
                    moveAlong();
                }
            });
        } else {
            finalize();
        }

    };


    // ---------------------------------------------------------------------------
    // Money format handler
    // ---------------------------------------------------------------------------
    Shopify.money_format = "${{amount}}";
    Shopify.formatMoney = function (cents, format) {
        if (typeof cents == 'string') { cents = cents.replace('.', ''); }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = (format || this.money_format);

        function defaultOption(opt, def) {
            return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal = defaultOption(decimal, '.');

            if (isNaN(number) || number == null) { return 0; }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
        }

        return formatString.replace(placeholderRegex, value);
    };

    return {

        resizeImage: function (src, size) {
            if (src) {
                if (size == null) {
                    return src;
                }

                if (size == 'master') {
                    return src.replace(/http(s)?:/, "");
                }

                var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

                if (match != null) {
                    var prefix = src.split(match[0]);
                    var suffix = match[0];

                    return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
                } else {
                    return null;
                }
            }
            else {
                return 'https://cdn.shopify.com/s/files/1/0591/6563/8808/files/place-holder.png';
            }
        },

        showRecentlyViewed: function (params) {

            var params = params || {};

            // Update defaults.
            jQuery.extend(config, params);

            // Read cookie.
            productHandleQueue = cookie.read();

            // Template and element where to insert.
            template = jQuery('#' + config.templateId);
            wrapper = jQuery('#' + config.wrapperId);

            // How many products to show.
            config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

            // If we have any to show.
            if (config.howManyToShow && template.length && wrapper.length && (productHandleQueue.length > 1)) {
                // Getting each product with an Ajax call and rendering it on the page.
                moveAlong();
            } else {
                jQuery('#recently-viewed').hide();
            }

        },

        getConfig: function () {
            return config;
        },

        clearList: function () {
            cookie.destroy();
        },

        recordRecentlyViewed: function (params) {

            var params = params || {};

            // Update defaults.
            jQuery.extend(config, params);

            // Read cookie.
            var recentlyViewed = cookie.read();

            // If we are on a product page.
            if (window.location.pathname.indexOf('/products/') !== -1) {

                // What is the product handle on this page.
                var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
                // In what position is that product in memory.
                var position = jQuery.inArray(productHandle, recentlyViewed);
                // If not in memory.
                if (position === -1) {
                    // Add product at the start of the list.
                    recentlyViewed.unshift(productHandle);
                    // Only keep what we need.
                    recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
                } else {
                    // Remove the product and place it at start of list.
                    recentlyViewed.splice(position, 1);
                    recentlyViewed.unshift(productHandle);
                }

                // Update cookie.
                cookie.write(recentlyViewed);

            }

        }

    };

})();
